import React, { useEffect, useState, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../../assets/css/gcadmin/adminsettings/AdminSettingsPage.css";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import Swal from "sweetalert2";

/* ── Handles 1 / "1" / true — any truthy variant Laravel might return ── */
const isOn = (val) => val === 1 || val === "1" || val === true;

/* ── Tab icons ── */
const TabIcons = {
  Personal: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>
    </svg>
  ),
  LibraryConfig: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3"/>
      <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/>
    </svg>
  ),
  BookConfig: () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M4 19.5A2.5 2.5 0 016.5 17H20" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5V4.5A2.5 2.5 0 016.5 2z" />
  </svg>
),
  Security: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    </svg>
  ),
  Notifications: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/>
      <path d="M13.73 21a2 2 0 01-3.46 0"/>
    </svg>
  ),
  Save: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z"/>
      <polyline points="17 21 17 13 7 13 7 21"/>
      <polyline points="7 3 7 8 15 8"/>
    </svg>
  ),
};

/* ── Form field ── */
const FormField = ({ label, type = "text", value, onChange, placeholder, hint }) => (
  <div className="gcAdmin-st-field">
    <label className="gcAdmin-st-label">{label}</label>
    {type === "textarea" ? (
      <textarea
        className="gcAdmin-st-input gcAdmin-st-input--textarea"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        rows={3}
      />
    ) : (
      <input
        className="gcAdmin-st-input"
        type={type}
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
      />
    )}
    {hint && <p className="gcAdmin-st-hint">{hint}</p>}
  </div>
);

/* ── Toggle row ── */
const ToggleRow = ({ label, desc, value, onChange }) => (
  <div className="gcAdmin-st-toggle-row">
    <div className="gcAdmin-st-toggle-info">
      <p className="gcAdmin-st-toggle-label">{label}</p>
      {desc && <p className="gcAdmin-st-toggle-desc">{desc}</p>}
    </div>
    <button
      className={`gcAdmin-st-toggle ${value ? "gcAdmin-st-toggle--on" : ""}`}
      onClick={() => onChange(!value)}
      aria-pressed={value}
    >
      <span className="gcAdmin-st-toggle-thumb" />
    </button>
  </div>
);

/* ── Success toast ── */
const Toast = ({ msg, onClose }) => {
  useEffect(() => { const t = setTimeout(onClose, 2800); return () => clearTimeout(t); }, [onClose]);
  return (
    <div className="gcAdmin-st-toast">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" stroke="#0f8a65" strokeWidth="1.8"/>
        <path d="M8 12l3 3 5-5" stroke="#0f8a65" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
      {msg}
    </div>
  );
};

/* ══════════════════════════════════════════════
   TAB PANELS
   ══════════════════════════════════════════════ */

/* Personal */
const PersonalTab = ({ onSave }) => {
  const [form, setForm] = useState({ name:"Super Admin", email:"superadmin@digilib.edu", phone:"+92 300 9876543" });
  const set = k => v => setForm(p => ({ ...p, [k]: v }));
  return (
    <div className="gcAdmin-st-panel">
      <div className="gcAdmin-st-panel-header">
        <TabIcons.Personal />
        <h5 className="gcAdmin-st-panel-title">Admin Profile</h5>
      </div>
      <FormField label="Admin Name"   value={form.name}  onChange={set("name")}  placeholder="Enter name" />
      <FormField label="Admin Email"  type="email" value={form.email} onChange={set("email")} placeholder="Enter email" />
      <FormField label="Phone Number" type="tel"   value={form.phone} onChange={set("phone")} placeholder="+92 300 0000000" />
      <button className="gcAdmin-st-save-btn" onClick={onSave}>
        <TabIcons.Save /> Update Profile
      </button>
    </div>
  );
};

/* Library Config */
const LibraryConfigTab = ({ onSave }) => {

    const { baseUrl, authToken } = useContext(AppContext);

    
  const [form, setForm] = useState({
    libraryName: "DigiLib University Library",
    email: "library@digilib.edu",
    phone: "+92 300 1234567",
    workingHours: "Mon - Fri : 8:00 AM - 5:00 PM",
    address: "Block A, University Campus, Lahore",
});
  const updateField = key => value =>
    setForm(prev => ({
        ...prev,
        [key]: value
    }));
    
  useEffect(() => {
    getLibraryConfig();
}, []);
const getLibraryConfig = () => {

    axios.post(
    `${baseUrl}/admin/libraryConfig/getLibraryConfiguration`,
    {},
    {
        headers: {
            Authorization: `Bearer ${authToken}`
        }
    }

        )

        .then((res) => {

            if (res.data.success) {

                const config = res.data.libraryConfig;

                if (config) {

                    setForm({

                        libraryName: config.library_name,

                        email: config.email,

                        phone: config.phone,

                        workingHours: config.working_hours,

                        address: config.address,

                    });

                }

            }

        })

        .catch((err) => {

            console.log(err);

        });

};
const saveLibraryConfig = () => {

    const formData = {
        library_name: form.libraryName,
        email: form.email,
        phone: form.phone,
        working_hours: form.workingHours,
        address: form.address,
    };

    axios.post(
        `${baseUrl}/admin/libraryConfig/updateLibraryConfiguration`,
        formData,
        {
            headers: {
                Authorization: `Bearer ${authToken}`
            }
        }
    )
        .then((res) => {

            if (res.data.success) {

                Swal.fire({
                    icon: "success",
                    title: "Updated Successfully!",
                    text: "Library configuration has been updated.",
                    confirmButtonColor: "var(--primary-color)",
                    timer: 2200,
                    showConfirmButton: false,
                });

            }

        })

        .catch((err) => {

            console.log(err);

            // Only the admin with id 1 is allowed to update this — show a
            // clear message instead of the generic failure toast.
            if (err.response && err.response.status === 403) {

                Swal.fire({
                    icon: "error",
                    title: "Not Authorized",
                    text: err.response.data?.message || "You are not authorized to update the library configuration.",
                    confirmButtonColor: "var(--primary-color)",
                });

                return;

            }

            Swal.fire({
                icon: "error",
                title: "Update Failed",
                text: "Something went wrong while saving configuration. Please try again.",
                confirmButtonColor: "var(--primary-color)",
            });

        });

};
  return (
    <div className="gcAdmin-st-panel">
      <div className="gcAdmin-st-panel-header">
        <TabIcons.LibraryConfig />
        <h5 className="gcAdmin-st-panel-title">Library Configuration</h5>
</div>

<FormField
  label="Library Name"
  value={form.libraryName}
  onChange={updateField("libraryName")}
  placeholder="Enter library name"
/>

<FormField
  label="Email"
  type="email"
  value={form.email}
  onChange={updateField("email")}
  placeholder="Enter library email"
/>

<FormField
  label="Phone"
  type="text"
  value={form.phone}
  onChange={updateField("phone")}
  placeholder="Enter phone number"
/>

<FormField
  label="Working Hours"
  type="textarea"
  value={form.workingHours}
  onChange={updateField("workingHours")}
  placeholder="e.g. Mon - Fri : 8:00 AM - 5:00 PM"
/>

<FormField
  label="Address"
  type="textarea"
  value={form.address}
  onChange={updateField("address")}
  placeholder="Enter library address"
/>

<button
className="gcAdmin-st-save-btn"
onClick={saveLibraryConfig}
>
    <TabIcons.Save />
    Save Configuration
</button>
    </div>
  );
};

/* Book Config */
const BookConfigTab = ({ onSave }) => {

  const { baseUrl, authToken } = useContext(AppContext);

  const [form, setForm] = useState({
    finePerDay: "10",
    maxIssueDays: "14",
    reservationExpiryHours: "24",
    maxBooksStudent: "3",
    maxBooksStaff: "5",
    lostBookFine: "200",
    damagedBookFine: "50",
  });

  const set = key => value =>
    setForm(prev => ({
      ...prev,
      [key]: value,
    }));

  useEffect(() => {
    getBookConfig();
  }, []);

  const getBookConfig = () => {

    axios.post(
      `${baseUrl}/admin/bookConfig/getBookConfiguration`,
      {},
      {
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      }
    )
      .then((res) => {

        if (res.data.success) {

          const config = res.data.bookConfiguration;

          if (config) {

            setForm({
              finePerDay: String(config.fine_per_day ?? ""),
              maxIssueDays: String(config.max_issue_days ?? ""),
              reservationExpiryHours: String(config.reservation_expiry_hours ?? "24"),
              maxBooksStudent: String(config.max_books_student ?? ""),
              maxBooksStaff: String(config.max_books_staff ?? ""),
              lostBookFine: String(config.lost_book_fine ?? ""),
              damagedBookFine: String(config.damaged_book_fine ?? ""),
            });

          }

        }

      })
      .catch((err) => {
        console.log(err);
      });

};

  const saveBookConfig = () => {

    const formData = {
      fine_per_day: form.finePerDay,
      max_issue_days: form.maxIssueDays,
      reservation_expiry_hours: form.reservationExpiryHours,
      max_books_student: form.maxBooksStudent,
      max_books_staff: form.maxBooksStaff,
      lost_book_fine: form.lostBookFine,
      damaged_book_fine: form.damagedBookFine,
    };

    axios.post(
      `${baseUrl}/admin/bookConfig/updateBookConfiguration`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      }
    )
      .then((res) => {

        if (res.data.success) {

          Swal.fire({
            icon: "success",
            title: "Updated Successfully!",
            text: "Book configuration has been updated.",
            confirmButtonColor: "var(--primary-color)",
            timer: 2200,
            showConfirmButton: false,
          });

        }

      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Update Failed",
          text: "Something went wrong while saving configuration. Please try again.",
          confirmButtonColor: "var(--primary-color)",
        });
      });

};
  return (

    <div className="gcAdmin-st-panel">

      <div className="gcAdmin-st-panel-header">

        <TabIcons.BookConfig />

        <h5 className="gcAdmin-st-panel-title">
          Book Configuration
        </h5>

      </div>

      <Row>

        <Col md={6}>

          <FormField
            label="Fine Per Day (Rs.)"
            type="number"
            value={form.finePerDay}
            onChange={set("finePerDay")}
            placeholder="10"
          />

        </Col>

        <Col md={6}>

          <FormField
            label="Max Issue Days"
            type="number"
            value={form.maxIssueDays}
            onChange={set("maxIssueDays")}
            placeholder="14"
          />

        </Col>

      </Row>

      <Row>

        <Col md={6}>

          <FormField
            label="Reservation Expiry (Hours)"
            type="number"
            value={form.reservationExpiryHours}
            onChange={set("reservationExpiryHours")}
            placeholder="24"
            
          />

        </Col>

        <Col md={6}>

          <FormField
            label="Max Books Per Student"
            type="number"
            value={form.maxBooksStudent}
            onChange={set("maxBooksStudent")}
            placeholder="3"
          />

        </Col>

      </Row>

      <Row>

        <Col md={6}>

          <FormField
            label="Max Books Per Staff"
            type="number"
            value={form.maxBooksStaff}
            onChange={set("maxBooksStaff")}
            placeholder="5"
          />

        </Col>

        <Col md={6}>

          <FormField
            label="Fine for Lost Book (Rs.)"
            type="number"
            value={form.lostBookFine}
            onChange={set("lostBookFine")}
            placeholder="200"
          />

        </Col>

      </Row>

      <Row>

        <Col md={6}>

          <FormField
            label="Fine for Damaged Book (Rs.)"
            type="number"
            value={form.damagedBookFine}
            onChange={set("damagedBookFine")}
            placeholder="50"
          />

        </Col>

      </Row>

      <button
        className="gcAdmin-st-save-btn"
        onClick={saveBookConfig}
      >
        <TabIcons.Save /> Save Book Config
      </button>

    </div>

  );

};
/* Security */
const SecurityTab = ({ onSave }) => {
  const [form, setForm] = useState({ current:"", newPwd:"", confirm:"" });
  const set = k => v => setForm(p => ({ ...p, [k]: v }));
  return (
    <div className="gcAdmin-st-panel">
      <div className="gcAdmin-st-panel-header">
        <TabIcons.Security />
        <h5 className="gcAdmin-st-panel-title">Security Settings</h5>
      </div>
      <FormField label="Current Password"  type="password" value={form.current} onChange={set("current")} placeholder="Enter current password" />
      <FormField label="New Password"      type="password" value={form.newPwd}  onChange={set("newPwd")}  placeholder="Enter new password" />
      <FormField label="Confirm Password"  type="password" value={form.confirm} onChange={set("confirm")} placeholder="Confirm new password"
        hint="Password must be at least 8 characters" />
      <button className="gcAdmin-st-save-btn" onClick={onSave}>
        <TabIcons.Save /> Update Password
      </button>
    </div>
  );
};

/* ── Notifications — simplified to just Email + In-App, wired to real backend ── */
const NotificationsTab = () => {
  const { baseUrl, loggedInUser, setLoggedInUser, authToken } = useContext(AppContext);

  const [prefs, setPrefs] = useState({
    email: false,
    inApp: false,
  });

  useEffect(() => {
    if (loggedInUser) {
      setPrefs({
        email: isOn(loggedInUser.email_notif),
        inApp: isOn(loggedInUser.inApp_notif),
      });
    }
  }, [loggedInUser]);

  const updateNotificationSettings = (emailStatus, inAppStatus) => {
    if (!loggedInUser?.id) return;

    const formData = new FormData();
    formData.append("lbadmin_id", loggedInUser.id);
    formData.append("email_notifications", emailStatus ? 1 : 0);
    formData.append("inapp_notifications", inAppStatus ? 1 : 0);

    axios.post(
      `${baseUrl}/admin/notifications/updateNotifications`,
      formData,
      { headers: { "Authorization": `Bearer ${authToken}` } }
    )
      .then((res) => {
        if (res.data.success) {
          setLoggedInUser(res.data.admin);

          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Notification settings updated",
            timer: 1200,
            showConfirmButton: false,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: res.data.message || "Could not update notification settings",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong while updating notification settings",
        });
      });
  };

  return (
    <div className="gcAdmin-st-panel">
      <div className="gcAdmin-st-panel-header">
        <TabIcons.Notifications />
        <h5 className="gcAdmin-st-panel-title">Notification Preferences</h5>
      </div>
      <div className="gcAdmin-st-toggles">
        <ToggleRow
          label="Email Notifications"
          desc="Receive notifications via email for reservations, overdue books, disputes, and updates."
          value={prefs.email}
          onChange={(newVal) => {
            setPrefs((p) => ({ ...p, email: newVal }));
            updateNotificationSettings(newVal, prefs.inApp);
          }}
        />
        <ToggleRow
          label="In-App Notifications"
          desc="Receive in-app notifications for alerts, reservations, and system updates."
          value={prefs.inApp}
          onChange={(newVal) => {
            setPrefs((p) => ({ ...p, inApp: newVal }));
            updateNotificationSettings(prefs.email, newVal);
          }}
        />
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════════
   MAIN PAGE
   ══════════════════════════════════════════════ */
const TABS = [
  { id:"personal",  label:"Personal",      Icon: TabIcons.Personal },
  { id:"library",   label:"Library Config", Icon: TabIcons.LibraryConfig },
   { id:"book", label:"Book Config", Icon: TabIcons.BookConfig },
  { id:"security",  label:"Security",      Icon: TabIcons.Security },
  { id:"notifications", label:"Notifications", Icon: TabIcons.Notifications },
];

const AdminSettingsPage = () => {
  const [activeTab, setActiveTab] = useState("personal");
  const [pageIn,    setPageIn]    = useState(false);
  const [toast,     setToast]     = useState(null);

  useEffect(() => { setTimeout(() => setPageIn(true), 60); }, []);

  const handleSave = () => setToast("Settings saved successfully!");

  const renderTab = () => {
    switch (activeTab) {
      case "personal":      return <PersonalTab      onSave={handleSave} />;
      case "library":       return <LibraryConfigTab onSave={handleSave} />;
      case "book":return <BookConfigTab onSave={handleSave} />;

      case "security":      return <SecurityTab      onSave={handleSave} />;
      case "notifications": return <NotificationsTab />;
      default:              return <PersonalTab      onSave={handleSave} />;
    }
  };

  return (
    <div className={`gcAdmin-st-page ${pageIn ? "gcAdmin-st-page--in" : ""}`}>
      <Container fluid className="gcAdmin-st-container">

        {/* Title */}
        <h2 className="gcAdmin-st-title">Settings</h2>

        {/* Tab bar */}
        <div className="gcAdmin-st-tabbar">
          {TABS.map(({ id, label, Icon }) => (
            <button
              key={id}
              className={`gcAdmin-st-tab ${activeTab === id ? "gcAdmin-st-tab--active" : ""}`}
              onClick={() => setActiveTab(id)}
            >
              <Icon />
              <span>{label}</span>
            </button>
          ))}
        </div>

        {/* Panel */}
        <div className="gcAdmin-st-panel-wrap">
          {renderTab()}
        </div>

      </Container>

      {/* Toast */}
      {toast && <Toast msg={toast} onClose={() => setToast(null)} />}
    </div>
  );
};

export default AdminSettingsPage;